// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"IN-z","carouselContainer":"JN-z"};